import { makeStyles } from '@material-ui/core/styles';
import { colorMap, ColorNames, TextColors } from '@/utils/constants';

const useAccountStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '& .content-wrapper .columns': {
        margin: muiTheme.spacing(0, -1),
      },
      '& .content-wrapper .left-column': {
        padding: muiTheme.spacing(0, 1),
        marginBottom: '0 !important',
      },
      '& .content-wrapper .right-column': {
        padding: muiTheme.spacing(0, 1),
      },
    },
    contentContainer: {
      '& .content-container__content': {
        paddingTop: '0 !important',
      },
    },
    detailContent: {
      '& > *': {
        marginBottom: muiTheme.spacing(2),
      },
      '& > *:last-child': {
        marginBottom: 0,
      },
    },
    detailContentCard: {
      backgroundColor: colorMap[ColorNames.mediumGray],
      borderRadius: '4px',
      padding: muiTheme.spacing(4),
      width: '100%',
    },
    detailContentForm: {
      '& form': {
        padding: '0 !important',
      },
    },
    contentTitle: {
      color: TextColors.light,
      marginBottom: `${muiTheme.spacing(2)}px !important`,
      fontSize: '20px !important',
      lineHeight: '24px !important',
    },
    pageHeader: {
      paddingBottom: muiTheme.spacing(1),
      [muiTheme.breakpoints.up('md')]: {
        paddingBottom: muiTheme.spacing(4),
      },
    },
    pageContent: {
      margin: muiTheme.spacing(0, -4),
      [muiTheme.breakpoints.up('md')]: {
        margin: 'auto',
      },
    },
  }),
  { name: 'Account' },
);

export default useAccountStyles;
